// Constants
export const DEFAULT_MAX_INPUT_LENGTH = 128;
export const MAX_EMAIL_LENGTH = 320;
export const MIN_PASSWORD_LENGTH = 8;

export const PASSWORD_REGEX =
  /^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*[0-9])[A-Za-z\d@%+/\\'!#$^?:.,(){}[\]~_-]*$/;
